import { CartItem } from "core/cart";
import { price } from "core/shared";
import { BaseLink } from "~/design-system/components";
import { cartDrawerAtom } from "~/modules/shared/atoms";
import { URLS } from "~/shared/urls";
import { CartDrawerItemQuantity } from "./CartDrawerItemQuantity";
import { CustomOptionsDisplay } from "./CustomOptionsDisplay";

export function CartDrawerItem(item: CartItem) {
  return (
    <div className="border-night flex h-fit flex-col gap-2 rounded-2xl border bg-white p-4 shadow-sm">
      <div className="flex items-center gap-4">
        <img
          src={item.product.images?.[0]?.url}
          alt={item.product.name}
          className="aspect-square w-24 rounded-xl object-cover object-center"
        />
        <div className="flex flex-1 justify-between gap-4">
          <div className="flex flex-col gap-2">
            <BaseLink
              onClick={cartDrawerAtom.close}
              to={URLS.ourCakes.viewProduct(item.product)}
              className="text-night font-playfair font-bold ease-in hover:underline"
            >
              {item.product.name}
            </BaseLink>
            <span className="text-xl font-extrabold">
              {price(item.total.finalPrice)}
            </span>
          </div>
          <CartDrawerItemQuantity item={item} />
        </div>
      </div>
      <CustomOptionsDisplay customOptions={item.customOptions} />
    </div>
  );
}
